import { transformWebChatBotMessageDtoToModel } from "../WebChatBotMessage/utils";

export const transformWebChatBotConversationDtoToModel =
  transformWebChatBotMessageDtoToModel;
